/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonnelResource } from '../models/PersonnelResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RankingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Classement des commerciaux
     * En cours de developpement : renvoie pour l'instant une liste de personnels sans classement. Ne pas utiliser.
     * @param dateDebut
     * @param dateFin
     * @returns any
     * @throws ApiError
     */
    public rankingIndex(
        dateDebut: string,
        dateFin: string,
    ): CancelablePromise<(string | Array<PersonnelResource>)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ranking',
            query: {
                'DATE_DEBUT': dateDebut,
                'DATE_FIN': dateFin,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
